import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-attivita',
  templateUrl: './attivita.component.html',
  styleUrls: ['./attivita.component.scss']
})
export class AttivitaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
